export const Logo = ({ className = "h-9 w-auto", variant = "dark" }) => (
  <img
    src={variant === "light" ? "/logo_mark_white.png" : "/logo_mark.png"}
    alt="Pilates Factory logó"
    className={`${className} object-contain`}
  />
);
